import { render, staticRenderFns } from "./LongTextBubble.vue?vue&type=template&id=989809dc&scoped=true&"
import script from "./LongTextBubble.vue?vue&type=script&lang=js&"
export * from "./LongTextBubble.vue?vue&type=script&lang=js&"
import style0 from "./LongTextBubble.vue?vue&type=style&index=0&id=989809dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989809dc",
  null
  
)

export default component.exports